import React from 'react'
import css from './style.scss'
import {FullPage} from 'components/container';
import store from 'utils/store'
import {push} from 'react-router-redux'
import FBComponent from 'components/shared/facebook/fb_component';
import PermissionsPopup from 'components/shared/facebook/permissions';


class ReconnectPage extends FBComponent{
  closePage=()=>{
    store.dispatch({type:"ADD_TOAST", message:"Your account is now reconnected."})
    store.dispatch(push("/"))
  }
  render(){
    return (
      <FullPage withContainer containerClass={css.setupAccountPage}>
        <PermissionsPopup
          onEveryThingIsBackToNormal={this.closePage}
        />
      </FullPage>
    )
  }
}

export default ReconnectPage



// WEBPACK FOOTER //
// ./src/components/setup/reconnect.js